import AlertMessages from "../../../../../components/messages/alert-message.js";
import projectUtils from "../../../../../utils/project-utils.js";

export const initialForm = {
  id: "",
  type_id: null,
  start_date: null,
  end_date: null,
  user_id: "",
  attach_id: null,
  attach: null,
  observation: "",
}

export function handleError(error){
  console.error(error);
  const {message} = error.response.data;
  let errMessage = AlertMessages[message] ?? message;
  projectUtils.swalErrorMessage("", errMessage, "Ok");
}

export function validate(form) {
  if (!form.user_id) return "Nome";
  if (!form.type_id) return "Motivo";
  if (!form.start_date) return "Data inicial";
  if (!form.end_date) return "Data final";
  return "";
}